import React from 'react';
import { ATTR_MESSAGES, getAttrTier } from '../../data/todayData';

const CpsRing: React.FC<{ cps: number; archetype: string; subArchetype?: string; attributes: Record<string, number>; moonAttribute?: string; onClick: () => void }> = ({ cps, archetype, subArchetype, attributes, moonAttribute, onClick }) => {
  const pct = Math.min(cps / 108, 1);
  const radius = 28;
  const circumference = 2 * Math.PI * radius;
  const strokeDash = pct * circumference;
  const tierColor = cps >= 70 ? '#c9a84c' : cps >= 50 ? '#48c9b0' : cps >= 30 ? '#5dade2' : '#a8b2d1';

  const sorted = Object.entries(attributes).sort((a, b) => b[1] - a[1]).slice(0, 3);

  return (
    <div
      onClick={onClick}
      className="glow-cps"
      style={{
        display: 'flex', alignItems: 'center', gap: '16px',
        padding: '24px', borderRadius: '18px',
        background: 'rgba(255,255,255,0.02)',
        cursor: 'pointer', marginBottom: '24px', transition: 'transform 0.2s',
      }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'none'; }}
    >
      <div style={{ position: 'relative', flexShrink: 0 }}>
        <svg width="68" height="68" viewBox="0 0 68 68">
          <circle cx="34" cy="34" r={radius} fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="4" />
          <circle cx="34" cy="34" r={radius} fill="none" stroke={tierColor} strokeWidth="4"
            strokeDasharray={`${strokeDash} ${circumference}`}
            strokeLinecap="round"
            transform="rotate(-90 34 34)"
            style={{ transition: 'stroke-dasharray 1s ease' }}
          />
        </svg>
        <div style={{
          position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: '16px', fontWeight: 700, color: tierColor, fontFamily: "Cinzel, serif" }}>{cps.toFixed(1)}</div>
          <div style={{ fontSize: '8px', color: 'rgba(255,255,255,0.3)', letterSpacing: '1px' }}>CPS</div>
        </div>
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: '16px', fontFamily: "Cinzel, serif", color: '#f4e4c1', fontWeight: 600, marginBottom: '2px' }}>
          {archetype}
        </div>
        {subArchetype && (
          <div style={{ fontSize: '11px', color: 'rgba(201,168,76,0.6)', marginBottom: '8px', fontStyle: 'italic' }}>
            {subArchetype}
          </div>
        )}
        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
          {sorted.map(([name, val]) => {
            const tier = getAttrTier(val);
            const isActive = moonAttribute === name;
            return (
              <span key={name} style={{
                fontSize: '10px', padding: '2px 8px', borderRadius: '10px',
                background: isActive ? `${tier.color}25` : `${tier.color}15`,
                color: tier.color,
                border: `1px solid ${isActive ? `${tier.color}50` : `${tier.color}25`}`,
                fontWeight: isActive ? 600 : 500,
              }}>
                {name} {val.toFixed(1)}
              </span>
            );
          })}
        </div>
        {moonAttribute && attributes[moonAttribute] !== undefined && (
          <p style={{ fontSize: '11px', color: 'rgba(255,255,255,0.35)', margin: '8px 0 0', fontStyle: 'italic', lineHeight: 1.4 }}>
            {ATTR_MESSAGES[moonAttribute] || 'Your energy shapes your reality.'}
          </p>
        )}
      </div>
      <span style={{ fontSize: '14px', color: 'rgba(201,168,76,0.3)', flexShrink: 0 }}>→</span>
    </div>
  );
};

export default CpsRing;
